<template>
    <div>
        <VpEditor v-model="description" placeholder="placeholder" />
    </div>
</template>

<script>
export default {
  data() {
    return {
      description: "",
    };
  },
};
</script>
